export default [
  { label: '姑妈姨妈', value: '39' },
  { label: '兄弟', value: '35' },
  { label: '商业合作关系', value: '11' },
  { label: '子女', value: '1' },
  { label: '表亲', value: '31' },
  { label: '女婿媳妇', value: '63' },
  { label: '未婚夫/未婚妻', value: '13' },
  { label: '朋友', value: '33' },
  { label: '孙子孙女', value: '19' },
  { label: '祖父祖母/外公外婆', value: '18' },
  { label: '岳父母', value: '62' },
  { label: '侄子', value: '42' },
  { label: '侄女', value: '41' },
  { label: '父母', value: '2' },
  { label: '姐妹', value: '36' },
  { label: '姐夫/妹夫/嫂子/弟妹', value: '64' },
  { label: '配偶', value: '3' },
  { label: '继子女', value: '15' },
  { label: '继父母', value: '14' },
  { label: '继兄弟', value: '37' },
  { label: '继姐妹', value: '38' },
  { label: '叔伯', value: '40' },
];



// WEBPACK FOOTER //
// ./src/constants/relations-by-australia-elec.js